import { useMutation } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const DeleteTeamTransactionContext = createContext(null);

type Props = {
  children: ReactElement;
};

const DeleteTeamTransactionProvider: FunctionComponent<Props> = ({
  children,
}) => {
  const { mutateAsync, data, isPending, error } = useMutation({
    mutationFn: async (payload: any) => {
      const data = await Api.delete(
        `tm/case-management/groups/${payload.group_id}/remove-transactions`,
        { data: payload },
      );
      return data;
    },
    onError: (err) => {
      throw err;
    },
  });

  const contextValue = useMemo(
    () => ({
      mutateAsync,
      data,
      error,
      isPending,
    }),
    [mutateAsync, data, error, isPending],
  );
  return (
    <DeleteTeamTransactionContext.Provider value={contextValue}>
      {children}
    </DeleteTeamTransactionContext.Provider>
  );
};

export default DeleteTeamTransactionProvider;
